module.exports = __webpack_public_path__ + "media/bootstrap-icons/cursor-60c3add1.svg";